<template>
  <b-card>
    <b-row
      align-h="end"
      class="mr-0"
      style="gap: 1rem;"
    >
      <div
        v-b-tooltip.hover
        title="A CND MTE agora possui limites diários de emissão. Clique para saber mais."
        class="text-primary"
        @click="openModalInfo"
      >
        <feather-icon
          icon="InfoIcon"
          size="32"
          stroke-width="0.8"
        />
      </div>
      <download-em-excel
        :filtro="filtroAtual"
        tipo="CNDs MTE"
        :api="apiMte"
      />
      <download-em-lote
        tipo-arquivo="todas as CND's MTE"
        tipo="Cnd MTE"
        :filtro="filtroAtual.filtroBy"
        :palavras-filtro="[['Regulares', 'Irregulares', 'Motivo']]"
        @baixar-lote="baixarEmLote"
      />
    </b-row>
    <cnd-mte-list
      ref="cndMteList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
    >
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <cnd-situacao
          v-if="props.column.field === 'situacao'"
          :value="props.row[props.column.field]"
          :descricao="props.row['situacaoDesc']"
        />
        <span
          v-if="props.column.field === 'razaoSocial'"
          @click.stop="$refs[`acoes${props.row.id}`].abrirArquivo(props.row)"
        >
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <cnd-acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :api="apiMte"
          :tipo-cnd="tipoCnd"
          :att-manual="true"
          :mais-info-button="openModalInfo"
          @atualizar-grid="atualizarGrid()"
        />
      </template>
    </cnd-mte-list>
  </b-card>
</template>

<script>

import api from '@/app/cnd-federal/shared/services/api'
import colunas from './shared/components/colunas'

export default {
  name: 'CndMteVisualizacao',
  components: {
    CndMteList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    CndAcoes: () => import('@/app/shared/components/cnd-acoes/CndAcoes.vue'),
    CndSituacao: () => import('@/app/shared/components/cnd-situacao/CndSituacao.vue'),
    DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      apiMte: api,
      tipoCnd: 'mte',
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social, Consultado em, Data de validade e próxima consulta',
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: true,
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'UltimaConsulta', 'ProximaConsulta'], valor: null }],
      filtrosRapidos: [
        {
          id: 'Regular',
          colunas: ['Situacao'],
          label: 'Regulares',
          valor: '1,2',
        },
        {
          id: 'Irregular',
          colunas: ['Situacao'],
          label: 'Irregulares',
          valor: '3',
        },
        {
          id: 'Motivo',
          colunas: ['Situacao'],
          label: 'Motivo não geração',
          valor: '4',
        }],
      criando: true,
      aplicando: false,
      filtroAtual: {},
    }
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.evento = this.carregar
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(this.tipoCnd, pagina, tamanhoPagina, filtro)
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.cndMteList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.cndMteList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    baixarEmLote(evt) {
      api.baixaEmLote(this.tipoCnd, this.filtroAtual, evt)
    },
    atualizarGrid() {
      this.$refs.cndMteList.buscar()
    },
    openModalInfo() {
      this.$swal({
        title: '<div class="text-danger">A CND MTE agora possui limites diários de emissão!</div>',
        html: `<div class="text-primary">
                  Gostaríamos de informar que o site de origem da 
                  <strong><ins><a href="https://eprocesso.sit.trabalho.gov.br" target="_blank">
                    CND MTE
                  </a></ins></strong> 
                  recebeu uma atualização recentemente que limitou nossas consultas. 
                  Agora é necessário realizar login com o GOV, além de possuir um limite diário de emissões para cada login.

                  <br><br>

                  Realizamos o login via certificado, portanto, será necessário ao menos um certificado cadastrado na plataforma para realizar as consultas. 
                  Você pode adicionar acessando o menu 
                  <strong><a href="../certificado/visualizar"><ins>
                    Cadastros > Certificados
                  </ins></a></strong> 
                  e clicando no botão <strong>Novo</strong>. A falta de certificados implica na não geração de informações.
                  
                  <br><br>
                  
                  Devido ao limite, a consulta da CND será realizada a partir da informação existente no campo <strong>Próxima consulta</strong> 
                  e poderá ser finalizada dentro de alguns dias. Lembre-se que cada login possui um limite de emissões, portanto, quanto mais certificados forem adicionados, 
                  mais rápido a atualização será finalizada.
                  
                  <br><br>
                  
                  Esse limite também impacta na atualização manual e haverão dias em que essa rotina estará temporariamente indisponível.
                </div>
                <br>
                <div class="text-danger">
                  Agradecemos a sua atenção e estamos à disposição em caso de dúvidas.
                  <br>
                  Atenciosamente, Equipe Monitor Contábil
                </div>`,
        icon: 'info',
        iconColor: '#ea5455',
        showConfirmButton: false,
        width: '47.5em',
      })
    },
  },
}
</script>
